import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RaderComponent } from './rader.component';



@NgModule({
  declarations: [
    RaderComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    RaderComponent
  ]
})
export class RaderModule { }
